module.exports = function (boApp)
{
  boApp.filter('format', function () {
    return function (str) {
      if (!str) return '';
      return str.replace(/\n/g, '<br>');
    }
  });
};
